import { useRef } from 'react';
import { predicateBoolean } from 'utilities/isType.js';
import { getDocument } from 'utilities/window.js';

export const BODY_MODAL_OPEN = 'modal-open';
export const DIV_MODAL_OPEN = 'Modal-Component--open';

type HasModalType = {
  isModal: boolean;
  key: ModalKeyType;
};

type NoModalType = Record<PropertyKey, never>;

type ModalType = HasModalType | NoModalType;

export const ModalKeyType = Object.freeze({
  Interstitial: 'Interstitial',
  mapScrubberExpandHook: 'mapScrubberExpandHook',
  fortyEightHr: 'fortyEightHr',
  expandscrubber: 'expand-scrubber',
});

export type ModalKeyType = (typeof ModalKeyType)[keyof typeof ModalKeyType];

/**
 * Simple Component To Share Modal Element Selectors across components
 * Adds Modal componant classes if is open that correlate with css styling
 */
export const ModalEls = ({
  isModal,
  modalBgListener,
  modalComponentClasses = [],
  /** Need key to ensure that location interstitial view does not interfere with 48hour view */
  key,
}: {
  modalBgListener?: () => void;
  modalComponentClasses?: string[];
} & ModalType) => {
  const document = getDocument();
  const body = useRef(document?.getElementsByTagName('body')[0]);
  const modalComponent = useRef(document?.getElementById('ModalComponent'));
  const modalBackground = useRef(document?.getElementById('ModalBackground'));
  const modalContent = useRef(document?.getElementById('ModalContent'));

  const modalComponentActiveClass = modalComponentClasses.concat([DIV_MODAL_OPEN]);

  const bodyClasslist = body.current?.classList;
  const modalClasslist = modalComponent.current?.classList;
  // only do this if is modal is set
  if (predicateBoolean(isModal) && bodyClasslist) {
    if (isModal) {
      if (!bodyClasslist.contains(key) && !bodyClasslist.contains(BODY_MODAL_OPEN)) {
        bodyClasslist.add(key, BODY_MODAL_OPEN);
        modalClasslist?.add(...modalComponentActiveClass);
        if (modalBgListener) {
          modalBackground.current?.addEventListener('click', modalBgListener);
        }
      }
    } else {
      // Check that the modal open is the correct one
      if (bodyClasslist.contains(key) && bodyClasslist.contains(BODY_MODAL_OPEN)) {
        bodyClasslist.remove(key, BODY_MODAL_OPEN);
        modalClasslist?.remove(...modalComponentActiveClass);
        if (modalBgListener) {
          modalBackground.current?.removeEventListener('click', modalBgListener);
        }
      }
    }
  }

  return { modalContent, modalComponent };
};
